"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentStage = void 0;
/**
 * Katal manifest templating will replace {{Stage}} with the correct stage value
 * during build time. Bundle for the appropriate stage will have the correct
 * stage string value used for fetching the url
 * https://katal.corp.amazon.com/#/developer/manifest/templatingcdk
 */
var useCurrentStage = function () {
    return '{{Stage}}'.toLowerCase();
};
exports.useCurrentStage = useCurrentStage;
